import { LocationCustomization } from "../_models/LocationCustomization";

export const LocationCustomizationMapper = {
    serverToLocal,
};

function serverToLocal(serverLocationCustomization) {
    return LocationCustomization({
        logo:               serverLocationCustomization.logo,
        loginBackground:    serverLocationCustomization.login_background,
        accentColor:        serverLocationCustomization.accent_color,
        headerColor:        serverLocationCustomization.header_color,
        managedByPMSCustomization:
            !!serverLocationCustomization.managed_by_pms_customization,
        ownAccentColor:     serverLocationCustomization.own_accent_color,
        ownHeaderColor:     serverLocationCustomization.own_header_color,
        ownLogo:            serverLocationCustomization.own_logo,
        inheritedFromOrganization:
            serverLocationCustomization.customization_organization_name,
    })
}